import { render, staticRenderFns } from "./invoice-note.vue?vue&type=template&id=2318c1ea"
import script from "./invoice-note.vue?vue&type=script&lang=js"
export * from "./invoice-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports